import { getReducerName } from 'data/dataSourceConstants';
import { useDispatch } from 'react-redux';
import dataTables from 'view/dataTables';
import { dataConfig } from 'data/dataConfig';
import { selectDataSet, selectCategory } from 'reducers/overviewDataSetReducer';
import { actions } from 'data/store';

function WorkAppJobNumberLink(props) {
	const dispatch = useDispatch();

	try {
		const { text, rowData, propertyData } = props;

		if (!rowData || !rowData.job_number) {
			return text || '-';
		}

		if (!propertyData || !propertyData.address) {
			return text || '-';
		}

		const source = rowData.source;
		const jobNumber = rowData.job_number; // The job number to filter by

		let dataSet, dataSource;

		if (source === 'BIS') {
			dataSet = 'jobApplications';
			dataSource = 'BIS';
		} else if (source === 'DOBNow') {
			dataSet = 'dobJobApplications';
			dataSource = 'OPEN_DATA';
		} else {
			return text || '-'; // Return job number as text if source is unknown
		}

		const handleClick = () => {
			// Select infrastructure category
			dispatch(selectCategory('infrastructure'));
			
			// Select the appropriate dataset
			const options = {
				dataSet: dataSet,
				reducerName: getReducerName(dataConfig[dataSet], dataSource),
				dataSource: dataSource,
				title: dataTables[dataSet].title,
				columns: dataTables[dataSet][dataSource].columns,
				tableView: dataSet === 'jobApplications' ? 'grouped' : null,
			};
			dispatch(selectDataSet(options));

			// Fetch data with the job number as a search filter
			const reducerName = getReducerName(dataConfig[dataSet], dataSource);
			dispatch(actions[reducerName].fetchData(propertyData.id, 'open', 1, jobNumber));
		};

		return (
			<button className="btn btn-link p-0 text-start" style={{ fontSize: 'inherit', fontWeight: 'normal' }} onClick={handleClick}>
				{jobNumber}
			</button>
		);
	} catch (error) {
		console.error('Error in WorkAppJobNumberLink:', error);
		return 'ERROR';
	}
}

export default WorkAppJobNumberLink;
